<template>
  <MgdAlert v-if="config.public.appEnv === 'staging'" variant="danger">
    <Icon name="lucide:triangle-alert" />
    <MgdAlertDescription class="flex flex-wrap items-center">
      This is a test environment. Orders placed here will not be fulfilled.
      Contact your territory manager to get the correct link.
    </MgdAlertDescription>
  </MgdAlert>
</template>

<script setup lang="ts">
const config = useRuntimeConfig();
</script>
